import { RepairOperationDto, RepairOperationReferenceDto } from "@/core/api/generated/v1";

/** Any entity DTO type according to @type EntityFormType */
export type RepairOperationDtoAny = RepairOperationDto | RepairOperationReferenceDto;

/** All entity DTO types according to @type EntityFormType */
export type RepairOperationDtoAll = RepairOperationDto & RepairOperationReferenceDto;

export class RepairOperationMapper {}
